import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["dialog"];
  static supportsInvokers = "command" in HTMLButtonElement.prototype;

  connect() {
    this.element.addEventListener("pointerenter", this.preload);
  }

  disconnect() {
    this.element.removeEventListener("pointerenter", this.preload);
  }

  open(event) {
    if (this.opensNatively) return;

    event.preventDefault();
    if (!this.hasDialogOutlet) return;

    this.dialogOutlet.loadLazyFrames();
    this.dialogOutlet.show();
  }

  preload = () => {
    if (this.hasDialogOutlet) this.dialogOutlet.loadLazyFrames();
  }

  get opensNatively() {
    return this.constructor.supportsInvokers && this.element.hasAttribute("commandfor");
  }
}
